<template>
  <div>
    <CreateAnnouncement @show-preview="showPreviewOverlay" />
  </div>
</template>

<script>
import CreateAnnouncement from '../components/CreateAnnouncement.vue';
import Swal from 'sweetalert2';
export default {
  components: {
    CreateAnnouncement,
  },
  methods: {
    showPreviewOverlay(data) {
      const para = data.body;
      const title = data.title;
      let previewContent = `
          <p style="font-size: 1.2rem; text-align: left">
            <b>${title}</b>
          </p>
          <div style="
            text-align: left;
            height: 500px;
            overflow-y: scrollable;
            font-size: 0.8em;
            ">
            ${para}
          </div>
        `;
      console.log(previewContent);
      Swal.fire({
        title: data.title.length > 60 ? data.title.slice(0, 56) + ' ...' : data.title,
        html: previewContent,
        width: '600px',
        // imageUrl: data.image,
        // imageAlt: "Preview Image",
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          title: 'preview-title',
          container: 'preview-overlay',
          content: 'preview-overlay-content',
          closeButton: 'preview-overlay-close',
        },
      });
    },
  },
};
</script>

<style>
.preview-overlay {
  /* Add your styles here */
}

.preview-overlay-content {
  /* Add your styles here */
  width: 80%;
  font-size: 1em;
}

.preview-overlay-close {
  /* Add your styles here */
}

.preview-title {
  background-color: rgb(233, 60, 60);
  color: white;
  text-align: left;
  padding: 25px;
  font-weight: normal;
  font-size: 1.2rem;
}
</style>
